import { Tooltip } from "antd";
import { TooltipPlacement } from "antd/lib/tooltip";

const TooltipComponent = ({
  title,
  children,
  arrowPointAtCenter = false,
  placement = "topLeft",
  textTransform = "capitalize",
}: {
  title: string;
  children: React.ReactNode;
  arrowPointAtCenter?: boolean;
  placement?: TooltipPlacement;
  textTransform?: React.CSSProperties["textTransform"];
}) => {
  return (
    <Tooltip
      placement={placement}
      title={title}
      destroyTooltipOnHide
      arrowPointAtCenter={arrowPointAtCenter}
      overlayInnerStyle={{
        textTransform: textTransform,
        backgroundColor: "#394452",
        borderRadius: 4,
        fontFamily: "lato",
        fontSize: 12,
        fontWeight: 400,
        padding: 8,
      }}
    >
      {children}
    </Tooltip>
  );
};

export default TooltipComponent;
